// Vector recreation of the owner's round logo so it stays sharp at any size
export const LogoMark = ({ size = 112, className = "", title = "Deaf Education Consulting logo, Michelle Andros" }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" {...(title ? { role: "img", "aria-label": title } : { "aria-hidden": true })} className={className}>
    <defs>
      <path id="logo-top" d="M 32 100 A 68 68 0 0 1 168 100" />
      <path id="logo-bottom" d="M 26 100 A 74 74 0 0 0 174 100" />
    </defs>
    <circle cx="100" cy="100" r="98" fill="#fdfaf2" />
    <circle cx="100" cy="100" r="88" fill="none" stroke="#1d3340" strokeWidth="1.6" />
    <text fill="#1d3340" fontFamily="'Nunito Sans', Arial, sans-serif" fontSize="13" fontWeight="700" letterSpacing="4.5">
      <textPath href="#logo-top" startOffset="50%" textAnchor="middle">CONSULTING</textPath>
    </text>
    <text x="100" y="110" textAnchor="middle" fill="#1d3340" fontFamily="'Allura', 'Great Vibes', cursive" fontSize="27">Deaf Education</text>
    <path d="M 58 120 Q 100 127 144 118" fill="none" stroke="#1d3340" strokeWidth="1.2" strokeLinecap="round" />
    <text fill="#1d3340" fontFamily="'Nunito Sans', Arial, sans-serif" fontSize="12" fontWeight="700" letterSpacing="4">
      <textPath href="#logo-bottom" startOffset="50%" textAnchor="middle">MICHELLE ANDROS</textPath>
    </text>
  </svg>
);
